// Happy Hour Configuration - Golden Pour
export const happyHourConfig = {
  // Happy Hour Schedule
  schedule: {
    days: ['monday', 'tuesday', 'wednesday', 'thursday'],
    startTime: '15:00', // 3:00 PM
    endTime: '17:00',   // 5:00 PM
    timezone: 'Australia/Melbourne'
  },

  // Happy Hour Offer
  offer: {
    type: '1+1', // Buy one get one
    title: 'Happy Hour',
    description: '1+1 on all beers',
    shortDescription: '1+1 Beers',
    badge: 'HAPPY HOUR',
    terms: [
      'Available Monday to Thursday, 3:00 PM - 5:00 PM',
      'Valid on Pot and Schooner sizes only',
      'Not available on Pints',
      'Cannot be combined with other offers',
      'Subject to availability'
    ]
  },

  // Applicable Glass Sizes
  applicableSizes: ['pot', 'schooner'], // Excludes pints

  // Display Settings
  display: {
    showBadge: true,
    showCountdown: false,
    showTerms: false, // Don't mention "not on pints" - just don't show badge on pints
    badgeColor: '#d4af37', // Gold
    badgeTextColor: '#1a1a1a' // Dark text on gold background
  },

  // Auto-refresh settings for TV mode
  autoRefresh: {
    enabled: true,
    intervalMinutes: 1 // Check every minute for happy hour status
  }
};